const items = [
  "Digital Advertising",
  "Brand Scaling",
  "Paid Social",
  "Creative Strategy",
  "Performance Marketing",
  "Content That Converts",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="border-y border-white/10 bg-black py-6 overflow-hidden"
    >
      <div className="fh-marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase tracking-tight text-2xl sm:text-3xl text-white px-6">
              {t}
            </span>
            <span className="text-yellow-400 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
